import { render, staticRenderFns } from "./HomeAvaliacao.vue?vue&type=template&id=4e198308&scoped=true"
import script from "./HomeAvaliacao.vue?vue&type=script&lang=js"
export * from "./HomeAvaliacao.vue?vue&type=script&lang=js"
import style0 from "./HomeAvaliacao.vue?vue&type=style&index=0&id=4e198308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e198308",
  null
  
)

export default component.exports